import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// News API
export const newsAPI = {
  getAll: (params) => api.get('/news', { params }),
  getBreaking: () => api.get('/news/breaking'),
  getBySlug: (slug) => api.get(`/news/${slug}`),
  create: (data) => api.post('/admin/news', data),
  update: (id, data) => api.put(`/admin/news/${id}`, data),
  delete: (id) => api.delete(`/admin/news/${id}`),
  getAllAdmin: () => api.get('/admin/news'),
};

// Products API
export const productsAPI = {
  getAll: (params) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/admin/products', data),
  update: (id, data) => api.put(`/admin/products/${id}`, data),
  delete: (id) => api.delete(`/admin/products/${id}`),
  getAllAdmin: () => api.get('/admin/products'),
};

// Services API
export const servicesAPI = {
  getAll: (params) => api.get('/services', { params }),
  getById: (id) => api.get(`/services/${id}`),
  create: (data) => api.post('/admin/services', data),
  update: (id, data) => api.put(`/admin/services/${id}`, data),
  delete: (id) => api.delete(`/admin/services/${id}`),
  getAllAdmin: () => api.get('/admin/services'),
};

// Newsletter API
export const newsletterAPI = {
  subscribe: (data) => api.post('/newsletter/subscribe', data),
  getAll: () => api.get('/admin/newsletter'),
};

// Banners API
export const bannersAPI = {
  getAll: (params) => api.get('/banners', { params }),
  create: (data) => api.post('/admin/banners', data),
  delete: (id) => api.delete(`/admin/banners/${id}`),
  getAllAdmin: () => api.get('/admin/banners'),
};

// Contact API
export const contactAPI = {
  send: (data) => api.post('/contact', data),
  getAll: () => api.get('/admin/contacts'),
  markRead: (id) => api.put(`/admin/contacts/${id}/read`),
};

// Categories API
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
};

// Stats API
export const statsAPI = {
  getAdmin: () => api.get('/admin/stats'),
};

// Seed API
export const seedAPI = {
  seed: () => api.post('/seed'),
};

// Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// Brevo / Newsletter Email API
export const brevoAPI = {
  getSettings: () => api.get('/admin/brevo/settings'),
  updateSettings: (data) => api.put('/admin/brevo/settings', data),
  broadcast: (data) => api.post('/admin/newsletter/broadcast', data),
};

export default api;
